import { useQuery } from '@tanstack/react-query';
import { acquireGraphToken } from '@/config/auth';

interface MyProfile {
  jobTitle: string | null;
  department: string | null;
}

async function fetchMyProfile(): Promise<MyProfile> {
  const token = await acquireGraphToken();
  if (!token) return { jobTitle: null, department: null };

  const response = await fetch(
    'https://graph.microsoft.com/v1.0/me?$select=jobTitle,department',
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (!response.ok) return { jobTitle: null, department: null };

  const data = await response.json();
  return { jobTitle: data.jobTitle || null, department: data.department || null };
}

/**
 * The signed-in user's job title and department for the profile menu.
 * Requires the User.Read scope granted at login (see loginRequest).
 */
export function useMyProfile(enabled: boolean) {
  return useQuery({
    queryKey: ['myProfile'],
    queryFn: fetchMyProfile,
    enabled,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}
